import { render, staticRenderFns } from "./form-remove.vue?vue&type=template&id=34ff6bc6&"
import script from "./form-remove.vue?vue&type=script&lang=js&"
export * from "./form-remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports